export const throttle = (func, limit) => {
    let inThrottle;
    let lastArgs;
    return function (...args) {
        lastArgs = args;
        if (!inThrottle) {
            func.apply(this, lastArgs);
            inThrottle = true;
            setTimeout(() => {
                inThrottle = false;
                if (lastArgs !== args) func.apply(this, lastArgs);
            }, limit);
        }
    };
};
